/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MailboxItemOrigin } from './MailboxItemOrigin';
import {
    MailboxItemOriginFromJSON,
    MailboxItemOriginFromJSONTyped,
    MailboxItemOriginToJSON,
    MailboxItemOriginToJSONTyped,
} from './MailboxItemOrigin';
import type { MailboxItemChannel } from './MailboxItemChannel';
import {
    MailboxItemChannelFromJSON,
    MailboxItemChannelFromJSONTyped,
    MailboxItemChannelToJSON,
    MailboxItemChannelToJSONTyped,
} from './MailboxItemChannel';
import type { MailboxItemLinkDTO } from './MailboxItemLinkDTO';
import {
    MailboxItemLinkDTOFromJSON,
    MailboxItemLinkDTOFromJSONTyped,
    MailboxItemLinkDTOToJSON,
    MailboxItemLinkDTOToJSONTyped,
} from './MailboxItemLinkDTO';

/**
 * 
 * @export
 * @interface MailboxSendDTO
 */
export interface MailboxSendDTO {
    /**
     * 
     * @type {MailboxItemOrigin}
     * @memberof MailboxSendDTO
     */
    Origin?: MailboxItemOrigin;
    /**
     * 
     * @type {MailboxItemChannel}
     * @memberof MailboxSendDTO
     */
    Channel?: MailboxItemChannel;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailboxSendDTO
     */
    To?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailboxSendDTO
     */
    Cc?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MailboxSendDTO
     */
    Bcc?: Array<string> | null;
    /**
     * 
     * @type {Array<MailboxItemLinkDTO>}
     * @memberof MailboxSendDTO
     */
    Links?: Array<MailboxItemLinkDTO> | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxSendDTO
     */
    Subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxSendDTO
     */
    Body: string;
}



/**
 * Check if a given object implements the MailboxSendDTO interface.
 */
export function instanceOfMailboxSendDTO(value: object): value is MailboxSendDTO {
    if (!('Body' in value) || value['Body'] === undefined) return false;
    return true;
}

export function MailboxSendDTOFromJSON(json: any): MailboxSendDTO {
    return MailboxSendDTOFromJSONTyped(json, false);
}

export function MailboxSendDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxSendDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Origin': json['Origin'] == null ? undefined : MailboxItemOriginFromJSON(json['Origin']),
        'Channel': json['Channel'] == null ? undefined : MailboxItemChannelFromJSON(json['Channel']),
        'To': json['To'] == null ? undefined : json['To'],
        'Cc': json['Cc'] == null ? undefined : json['Cc'],
        'Bcc': json['Bcc'] == null ? undefined : json['Bcc'],
        'Links': json['Links'] == null ? undefined : ((json['Links'] as Array<any>).map(MailboxItemLinkDTOFromJSON)),
        'Subject': json['Subject'] == null ? undefined : json['Subject'],
        'Body': json['Body'],
    };
}

export function MailboxSendDTOToJSON(json: any): MailboxSendDTO {
    return MailboxSendDTOToJSONTyped(json, false);
}

export function MailboxSendDTOToJSONTyped(value?: MailboxSendDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Origin': MailboxItemOriginToJSON(value['Origin']),
        'Channel': MailboxItemChannelToJSON(value['Channel']),
        'To': value['To'],
        'Cc': value['Cc'],
        'Bcc': value['Bcc'],
        'Links': value['Links'] == null ? undefined : ((value['Links'] as Array<any>).map(MailboxItemLinkDTOToJSON)),
        'Subject': value['Subject'],
        'Body': value['Body'],
    };
}

